import React from "react"
import { connect } from "react-redux"
import ShopMap from "./ShopMap"
import ShopMapCard from "./ShopMapCard"
import { withTranslation } from "react-i18next"
import DisplayMessage from "./DisplayMessage"

export const CARD_MARGIN = 5
const NO_SHOP = "NO_SHOP"

class ShopMapView extends React.Component {
  constructor(props) {
    super(props)

    this.carousel = React.createRef()
  }

  componentDidMount() {
    this.setScroll()
  }

  componentDidUpdate() {
    this.setScroll()
  }

  onPreSelect = (shop) => {
    this.props.onPreSelect(shop === this.props.selectedShop ? NO_SHOP : shop)
  }

  setScroll = () => {
    const { selectedShop } = this.props
    const shopId = selectedShop == null || selectedShop === NO_SHOP ? -1 : selectedShop.id

    const carousel = this.carousel.current
    const carouselWidth = carousel && carousel.children[0] && carousel.children[0].children[0]
    const margin = 2 * CARD_MARGIN
    const width = (carouselWidth && carouselWidth.scrollWidth + margin) || 0
    const index = this.props.shops.map((s) => s.id).indexOf(shopId)

    let position = width * index
    if (width * 1.5 < carousel.offsetWidth) position = position - width / 2 + 2 * margin
    this.carousel.current.scrollLeft = Math.max(0, position)
  }

  render() {
    const {
      shops,
      onSelect,
      shouldDisplayPrice,
      promoInActiveCart,
      orderServices,
      t,
      vehicleTypeId
    } = this.props
    let { selectedShop } = this.props
    if (selectedShop === NO_SHOP) selectedShop = null
    return (
      <div>
        {shops.length > 0 && (
          <div className="mapContainer">
            <ShopMap
              shops={shops}
              selectedShop={selectedShop}
              onClickMarker={this.onPreSelect}
              shouldDisplayPrice={shouldDisplayPrice}
              onSelect={onSelect}
              orderServices={orderServices}
              vehicleTypeId={vehicleTypeId}
            />
          </div>
        )}
        {promoInActiveCart && (
          <div className="caradvise-electric-blue-gradient map-view-promo-banner">
            {t("promoPriceAtCheckoutText")}
          </div>
        )}
        <DisplayMessage message={t("common:mdHdShopsLabel")} vehicleTypeId={vehicleTypeId} />
        <div ref={this.carousel} className="shopMapCardsContainer">
          <div className="shopMapCardsGroup">
            {shops.map((shop) => {
              return (
                <ShopMapCard
                  shop={shop}
                  selectedShop={selectedShop}
                  onSelect={onSelect}
                  onPreSelect={this.onPreSelect}
                  shouldDisplayPrice={shouldDisplayPrice}
                  orderServices={orderServices}
                  vehicleTypeId={vehicleTypeId}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state
  const activeCarts = user.active_carts
  const promoInActiveCart = activeCarts[0] && activeCarts[0].promotions[0]

  return {
    promoInActiveCart: !!promoInActiveCart
  }
}

export default connect(mapStateToProps, {})(withTranslation("shopMapView")(ShopMapView))
